<template>
    <v-row justify="center" no-gutters>
        <v-col cols="12" md="8">
            <v-img src="@/assets/logo_banner.png" max-width="434px" class="ma-auto"></v-img>
            <v-card class="pa-3 ma-3">
                <v-card-title><h1 class="title text-uppercase">En quelques mots</h1></v-card-title>
                <v-card-text>Ludi’Heath est le projet commun du Hacking Health et du Collectif
                    Ludique Bisontin. Un nouvel événement à Besançon pour générer l’émulsion nécessaire à de
                    nouveaux projets innovants du jeu, sous toutes ses formes, au service de la santé.

                    Le principe de cet événement est de réunir des créateurs (informaticiens, graphistes,
                    musiciens, etc) et des professionnels de santé autour de problématiques médicales ou
                    d’accessibilité et d'y apporter un début de réponse de façon ludique.
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn @click="$router.push({name:'ourevent'})" text color="orange">En savoir plus</v-btn>
                    <v-btn @click="$router.push({name:'subscribe'})" text color="orange">S'inscrire</v-btn>
                    <contact-us color="orange" v-if="$vuetify.breakpoint.smAndUp"></contact-us>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import ContactUs from "./ContactUs";
    export default {
        name: "Description",
        components: {ContactUs}
    }
</script>

<style scoped>

</style>